import { FunctionComponent, memo } from 'react';
import { StoryCardEditorialContent } from '../../../services';
import { FeedCardContentCommon, FeedCardProps } from '../../../shared';

export const FeedCardEditorial: FunctionComponent<FeedCardProps> = memo(({ card, chatId }) => {
  const {
    storyId,
    id,
    type,
    content,
    isPinnedToTopOfNewsFeed,
    isPinnedToTopOfStory,
    mentionedUsers,
  } = card;

  const { sourceName, headline, subHeadline, text, textHTML } =
    content as StoryCardEditorialContent;

  return (
    <FeedCardContentCommon
      type={type}
      isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
      isPinnedToTopOfStory={isPinnedToTopOfStory}
      storyId={storyId}
      cardId={id}
      chatId={chatId}
      source={sourceName}
      title={headline}
      subTitle={subHeadline}
      text={text}
      htmlText={textHTML}
      mentionedUsers={mentionedUsers}
    />
  );
});
